var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchDetailsTwo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2061 11.0303L11.2244 11.0484L11.2444 11.0646L12.9049 12.405L12.948 12.4397C13.0321 12.5824 13.0135 12.7709 12.8924 12.8934C12.7551 13.0321 12.5366 13.035 12.396 12.9021L11.0305 11.3371L11.0305 11.337L11.0279 11.3341L10.9879 11.289C10.9639 11.2553 10.9503 11.2139 10.9503 11.1706C10.9503 11.1167 10.9714 11.0659 11.0072 11.0291C11.0634 10.9745 11.1504 10.9749 11.2061 11.0303ZM6.07547 1.00035C7.41973 1.00035 8.71004 1.54005 9.66223 2.50249C10.6146 3.4651 11.1506 4.77182 11.1506 6.13545C11.1506 8.97655 8.87334 11.2706 6.07547 11.2706C3.27759 11.2706 1.00035 8.97655 1.00035 6.13545C1.00035 3.29435 3.27759 1.00035 6.07547 1.00035Z",
    stroke: "black",
    fill: "none",
    strokeWidth: 1.00069
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDetailsTwo);
export default __webpack_public_path__ + "static/media/SearchDetailsTwo.25fd9402e0d157f98aae882aecda4e2b.svg";
export { ForwardRef as ReactComponent };